import { useNotifications } from '../../hooks/notifications/useNotifications';
import { useNotificationsPage } from '../../hooks/notifications/useNotificationsPage';
import { NotificationsHeader } from './NotificationsHeader';
import { NotificationsList } from './NotificationsList';
import { EmptyNotifications } from './EmptyNotifications';
import { NotificationListSkeleton } from '../../components/skeletons/NotificationSkeleton';

/**
 * Notifications page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export default function NotificationsPage() {
  // Business logic hooks (platform-agnostic)
  const { unreadNotifications, readNotifications, isLoading, tripUrls } = useNotifications();

  // Auto-mark notifications as read when page loads
  useNotificationsPage();

  // Render
  return (
    <div className="min-h-screen bg-subtle">
      <NotificationsHeader />

      <div className="max-w-3xl mx-auto">
        {isLoading ? (
          <NotificationListSkeleton />
        ) : unreadNotifications.length === 0 && readNotifications.length === 0 ? (
          <EmptyNotifications />
        ) : (
          <NotificationsList
            unreadNotifications={unreadNotifications}
            readNotifications={readNotifications}
            tripUrls={tripUrls}
          />
        )}
      </div>
    </div>
  );
}
